import { render, staticRenderFns } from "./TransporterConfig.vue?vue&type=template&id=2d5a6c9f&"
import script from "./TransporterConfig.vue?vue&type=script&lang=js&"
export * from "./TransporterConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports